/**
 * @generated SignedSource<<25666ede4b5c10011ff79c5358d4bad0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetSignalOverview_widget$data = {
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetSignalOverviewContentMediumPaginated">;
  readonly " $fragmentType": "WidgetSignalOverview_widget";
};
export type WidgetSignalOverview_widget$key = {
  readonly " $data"?: WidgetSignalOverview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetSignalOverview_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetSignalOverview_widget",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetSignalOverviewContentMediumPaginated"
    }
  ],
  "type": "WidgetSignalOverview",
  "abstractKey": null
};
})();

(node as any).hash = "fcbe62dcf11c98abfa6f7068e8ab1dc8";

export default node;
